import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1792c2f9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "kt_post" }
const _hoisted_2 = { id: "kt_content_container" }
const _hoisted_3 = {
  class: "card card-flush pb-0 bgi-position-y-center bgi-no-repeat mb-10",
  style: {"background-size":"auto calc(100% + 10rem)","background-position-x":"100%","background-image":"url('/svg/illustrations/user-management-card.png')"}
}
const _hoisted_4 = { class: "card-header pt-10" }
const _hoisted_5 = { class: "d-flex align-items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-circle me-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "symbol-label bg-transparent text-primary border border-secondary border-dashed" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x svg-icon-primary" }, [
      /*#__PURE__*/_createElementVNode("img", {
        alt: "Logo",
        class: "h-50px",
        src: "/svg/logos/logo-devfactory-small.svg"
      })
    ])
  ])
], -1))
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-muted fw-bolder" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "mx-3" }),
  /*#__PURE__*/_createTextVNode(" 5 admins "),
  /*#__PURE__*/_createElementVNode("span", { class: "mx-3" }, "|"),
  /*#__PURE__*/_createTextVNode(" 10 users ")
], -1))
const _hoisted_10 = { class: "card-body pb-0" }
const _hoisted_11 = { class: "d-flex overflow-auto h-55px" }
const _hoisted_12 = { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap" }
const _hoisted_13 = { class: "nav-item" }
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = { class: "nav-item" }
const _hoisted_16 = {
  key: 0,
  class: "card"
}
const _hoisted_17 = { key: 1 }
const _hoisted_18 = {
  key: 2,
  class: "card"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTUsers = _resolveComponent("KTUsers")!
  const _component_KTRoles = _resolveComponent("KTRoles")!
  const _component_KTPermissons = _resolveComponent("KTPermissons")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.$t("usersManagement")), 1),
              _hoisted_9
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", _hoisted_13, [
                _createElementVNode("span", {
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleUser && _ctx.handleUser(...args))),
                  class: _normalizeClass(["nav-link text-active-primary me-6", [_ctx.isUserGroup && 'active']])
                }, _toDisplayString(_ctx.$t("users")), 3)
              ]),
              _createElementVNode("li", _hoisted_14, [
                _createElementVNode("span", {
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleRoles && _ctx.handleRoles(...args))),
                  class: _normalizeClass(["nav-link text-active-primary me-6", [_ctx.isRoles && 'active']])
                }, _toDisplayString(_ctx.$t("roles")), 3)
              ]),
              _createElementVNode("li", _hoisted_15, [
                _createElementVNode("span", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handlePermission && _ctx.handlePermission(...args))),
                  class: _normalizeClass(["nav-link text-active-primary me-6", [_ctx.isPermission && 'active']])
                }, _toDisplayString(_ctx.$t("permissions")), 3)
              ])
            ])
          ])
        ])
      ]),
      (_ctx.isUserGroup)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createVNode(_component_KTUsers)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isRoles)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_KTRoles)
          ]))
        : _createCommentVNode("", true),
      (_ctx.isPermission)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createVNode(_component_KTPermissons)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}